import React from 'react';
import type { Node } from 'react';
import styled from '@emotion/styled';

import { useComponentTheme } from '../useComponentTheme';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  className?: string,
  mode?: 'default' | 'Welcome:Rewards',
  width: string
};

/**
 * ### Available modes
 * * `default`: Used when a mode is not specified
 * * `Welcome:Rewards`: The 'My Rewards' section on the Welcome page
 *
 * ### Example
 * ```
 default {
    ...
    Separator: {
      default: {
        backgroundColor: theme.color.lighterGrey
      },
      'Welcome:Rewards': {
        backgroundColor: '#c0ff33'
      }
    }
    ...
  }
 * ```
 * */

const _Separator = ({ className, mode, width = '100%' }: Props): Node => {
  const componentTheme = useComponentTheme(theme => theme.components.Separator, mode);

  return <Line className={className} componentTheme={componentTheme} data-test="separator" width={width} />;
};

export const Separator = withSpacingStyles(_Separator);

const Line = styled('hr')(({ componentTheme, width }) => `
  margin-top: 0;
  margin-bottom: 16px;
  background-color: ${componentTheme.backgroundColor};
  border: none;
  width: ${width};
  height: 1px;
`);
